import { Alert, Button, Snackbar } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from "react-router-dom";
import { AUTHORIZATION, HOSTNAME_PATHI } from "../../../common/constants";
import HorizontalNav from "../../../components/HorizontalNav";
import authTokenForAPI from "../../../utils/authTokenForAPI";
import {
  primaryColor,
  secondaryColor,
  ternaryColor,
} from "../../../utils/styleObjs";

const ListDesignation = () => {
  const [listDesignation, setListDesignation] = useState([]);
  const [snack, setSnack] = useState({
    open: false,
    severity: "success",
    msg: "",
  });
  const history = useNavigate();
  useEffect(() => {
    trackPromise(
      axios
        .get(`${HOSTNAME_PATHI}/designations`, {
          headers: { [AUTHORIZATION]: authTokenForAPI() },
        })
        .then((res) => {
          console.log(res);
          setListDesignation(res.data.map((v) => ({ ...v, id: v.ref })));
        })
    );
  }, []);
  const navLinks = [{ key: 0, label: "Home", path: "/home" }];

  const columns = [
    { field: "ref", headerName: "ID" },
    { field: "designation", headerName: "Designation name", width: 150 },
  ];

  return (
    <>
      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
      <HorizontalNav navLinks={navLinks} pageName="Designations" />
      <Box display={"flex"} justifyContent={"space-between"}>
        <h2>Designations</h2>
        <Button
          variant="contained"
          sx={{
            margin: "20px",
            float: "right",
          }}
          onClick={() => history("/designation/add")}
        >
          Add Designation
        </Button>
      </Box>
      <div>
        <DataGrid
          density="compact"
          showCellRightBorder
          autoHeight
          sx={{
            borderColor: primaryColor,
            backgroundColor: ternaryColor,
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: secondaryColor,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: primaryColor,
              color: "white",
              fontWeight: "600",

              "& .MuiSvgIcon-root": {
                color: "white",
              },
            },
            "& .MuiDataGrid-cellCheckbox .MuiSvgIcon-root": {
              color: primaryColor,
            },
          }}
          onRowClick={(v) => {
            console.log(v);
            history(`/designation/edit/${v.id}`);
          }}
          rows={listDesignation}
          columns={columns}
        />
      </div>
    </>
  );
};
export default ListDesignation;
